import { useState } from 'react';

import PropTypes from 'prop-types';
import { BsLockFill } from 'react-icons/bs';

import AddonActivateModal from '#globalComponents/addons/AddonActivateModal';
import Checkbox from '#globalComponents/Checkbox/Checkbox';
import { PHONE_ADDON } from '#lib/addons/addonConfigs';

/**
 * Opt-in for revealing phone numbers during the run. Without the add-on the box is greyed out and
 * the link opens the add-on modal — the same gate as the masked numbers in the contact list.
 */
export default function PhoneRevealOption({ checked, onChange, hasPhoneAddon }) {
	const [modalOpen, setModalOpen] = useState(false);

	return (
		<div>
			<Checkbox
				id="enrichment-reveal-phones"
				checked={hasPhoneAddon && checked}
				onChange={onChange}
				disabled={!hasPhoneAddon}
				label="Durchwahlen & Mobilnummern aufdecken"
			/>
			<p className="mt-1 pl-6 text-xs text-bgBase-800">
				{hasPhoneAddon ? (
					'Ansprechpartner mit eigener Nummer werden bevorzugt.'
				) : (
					<>
						<BsLockFill className="mr-1 inline h-3 w-3 align-[-1px]" />
						Mit dem Telefonnummern-Add-on.{' '}
						<button
							type="button"
							onClick={() => setModalOpen(true)}
							className="font-medium text-primary-600 underline underline-offset-2 hover:text-primary-700"
						>
							Freischalten
						</button>
					</>
				)}
			</p>
			<AddonActivateModal
				addon={PHONE_ADDON}
				isOpen={modalOpen}
				onClose={() => setModalOpen(false)}
				title="Telefonnummern freischalten"
				highlight="Durchwahlen und Mobilnummern der Ansprechpartner direkt bei der Anreicherung aufdecken."
				benefits={PHONE_ADDON.benefits}
				onActivated={() => onChange(true)}
			/>
		</div>
	);
}

PhoneRevealOption.propTypes = {
	checked: PropTypes.bool.isRequired,
	onChange: PropTypes.func.isRequired,
	hasPhoneAddon: PropTypes.bool.isRequired,
};
